/**
 * 현재 이 토큰이 구글로그인인지, 이메일/패스워드 로그인인지 구분하는
 * 거의 유일한 방법은 scope 값을 이용하는 방법이다. (좋은 방법 아니다)
 *
 * 현재 저장된 값 혹은 형식과 다르면 센트리에 에러 혹은 경고 보내도록 객체 출력하는 상황.
 * 
 * 하단 scope 값이 cognito, google 정책등에 의해 변경되면 고쳐야 한다.
 */
const GOOGLE_SCOPE_ARRAY = ["openid", "profile", "email"];
const EMAIL_SCOPE_ARRAY = ["aws.cognito.signin.user.admin"];

const _isSameValueIgnoreOrder = (inputArray, targetArray) => {
  /**
   * 위 배열값과 동일한 scope를 가지면 true
   */
  if (inputArray.length !== targetArray.length) {
    return false;
  }

  return targetArray.every(targetValue => inputArray.includes(targetValue));
};

const _hasAnyValue = (inputArray, targetArray) => {
  /**
   * 위 배열값중 1개라도 가지면 true
   */
  return targetArray.some(targetValue => inputArray.includes(targetValue));
};

const _getWarnMsg = scopeArr => {
  return `wrong scope: ${scopeArr.toLocaleString()}`;
};

function _checkArrayType(inputArray) {
  if (_isSameValueIgnoreOrder(inputArray, GOOGLE_SCOPE_ARRAY)) {
    return { tokenAuthType: "google", warning: null };
  } else if (_isSameValueIgnoreOrder(inputArray, EMAIL_SCOPE_ARRAY)) {
    return { tokenAuthType: "cognito_email", warning: null };
  } else if (_hasAnyValue(inputArray, GOOGLE_SCOPE_ARRAY)) {
    return { tokenAuthType: "google", warning: _getWarnMsg(inputArray) };
  } else if (_hasAnyValue(inputArray, EMAIL_SCOPE_ARRAY)) {
    return { tokenAuthType: "cognito_email", warning: _getWarnMsg(inputArray) };
  } else {
    return { tokenAuthType: "google", warning: _getWarnMsg(inputArray) };
  }
}

const getLoginProvider = ({ accessToken }) => {
  try {
    const { scope } = accessToken.payload;
    const scopeArray = scope.trim().split(/\s+/);

    return _checkArrayType(scopeArray);
  } catch (error) {
    return { tokenAuthType: "google", error };
  }
};

export { getLoginProvider };
